const en = require('./en.json')
const am = require('./am.json')
const oro = require('./oro.json')
const tig = require('./tig.json')

const translations = {
    en, am, oro, tig
}

export default function translate(key, lang){
    return translations[lang][key]
}